import { DashboardControllerV3ApiFactory } from "@eu.mdotm.api/sphere";
import { useApiGen } from "$root/api/hooks";
import { useUserValue } from "$root/functional-areas/user";
import { useQueryReactor, useQueryNoRefetch } from "$root/third-party-integrations/react-query/hooks";
import { atom, useAtom } from "@mdotm/shadcn/legacy/reactivity";

export const trace$ = atom<{ creation_time: string }>({
	creation_time: new Date().toISOString(),
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useWidgetsData = () => {
	const [currentWidgetsData, setWidgetsData] = useAtom(trace$);
	const currentUser = useUserValue();

	const widgetsData = useApiGen(DashboardControllerV3ApiFactory);

	const { refetch: getCurrentWidgetsData, ...query } = useQueryNoRefetch(["retrieveTraceOptionData"], {
		enabled: Boolean(currentUser.id),
		queryFn: async () => {
			const { data } = await widgetsData.dashboardControllerGetTrace();
			return data;
		},
	});
	useQueryReactor(query, {
		onSuccess: (data) => {
			setWidgetsData({ creation_time: data });
		},
		onError: (e) => {
			console.error(e);
		},
	});

	return { currentWidgetsData, getCurrentWidgetsData };
};

export default useWidgetsData;
